import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import config from "../../config";
import { encryptData } from "../../utils/cryptoUtils";

const ListBusinessRulesEngine = () => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchRules = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${config.API_BASE_URL}get_business_rules`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: encryptData({}), // Send empty payload
      });
      
      const data = await res.json();
      if (data.status === 200) {
        setRules(data.data || []);
      } else {
        setError(data.message || 'Failed to fetch rules');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error("Error fetching rules:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRules();
  }, []);

  const handleStatusChange = async (id, action) => {
    try {
      const res = await fetch(`${config.API_BASE_URL}update_business_rule_status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: encryptData({ id, action }),
      });
      const data = await res.json();
      if (data.status === 200) {
        fetchRules();
      } else {
        alert(data.message || "Failed to update status");
      }
    } catch (err) {
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 className="mb-1">Business Rules</h3>
          <div className="text-muted">Numeric, range and text-based rules in one engine.</div>
        </div>
        <Link to="/dashboard/add-business-rules-engine" className="btn btn-primary">Create Rule</Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0 align-middle">
              <thead className="table-light">
                <tr>
                  <th>Code</th>
                  <th>Rule Name</th>
                { /* <th>Aggregation</th>
                  <th>Version</th> */ }
                  <th>Status</th>
                  <th/>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-5">Loading...</td>
                  </tr>
                ) : rules.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-5">No rules created yet.</td>
                  </tr>
                ) : (
                  rules.map((r) => (
                    <tr key={r.id}>
                      <td><code>{r.rule_code}</code></td>
                      <td>{r.rule_name}</td>
                     { /* <td>{r.aggregation_type}</td>
                      <td>{r.version}</td> */ }
                      <td>
                        <span className={`badge bg-${r.status.toLowerCase() === 'active' ? 'success' : (r.status.toLowerCase() === 'draft' ? 'secondary' : 'warning')}`}>
                          {r.status}
                        </span>
                      </td>
                      <td className="text-end">
                        <Link className="btn btn-sm btn-outline-primary me-2" to={`/dashboard/add-business-rules-engine?id=${r.id}`}>Edit</Link>
                        {r.status === 'DRAFT' && (
                          <button className="btn btn-sm btn-success" onClick={() => handleStatusChange(r.id, 'activate')}>Activate</button>
                        )}
                        {r.status === 'ACTIVE' && (
                          <button className="btn btn-sm btn-warning" onClick={() => handleStatusChange(r.id, 'deactivate')}>Deactivate</button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListBusinessRulesEngine;
